import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import firebase from '../../firebase/firebaseConfig';
import { Button, Avatar, Slider, CircularProgress } from '@material-ui/core';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import { makeStyles } from '@material-ui/core/styles';

function Alert(props) {
  return <MuiAlert elevation={6} variant='filled' {...props} />;
}

const levelMarks = [
  {
    value: 10,
    label: 'B',
  },
  {
    value: 40,
    label: 'I',
  },
  {
    value: 70,
    label: 'A',
  },
];
const useStyles = makeStyles((theme) => ({
  content: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.default,
    padding: theme.spacing(3),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatarDiv: {
    display: 'flex',
    alignItems: 'baseline',
  },
  avatar: {
    marginRight: '10px',
    width: theme.spacing(7),
    height: theme.spacing(7),
  },
  sliderGroup: {
    display: 'flex',
    wrap: 'no-wrap',
    '@media (max-width: 670px)': {
      flexDirection: 'column',
      alignItems: 'center',
    },
  },
  slider: {
    width: theme.spacing(25),
    marginRight: '20px',
  },
  button: {
    marginBottom: '50px',
  },
}));

const AccountInfo = ({ user }) => {
  const classes = useStyles();
  const history = useHistory();
  const [openErrorToast, setOpenErrorToast] = useState(false);
  const [openSuccessToast, setOpenSuccessToast] = useState(false);

  const openToast = (toast) => {
    // setOpenClassSignIn(true);

    switch (toast) {
      case 'success':
        setOpenSuccessToast(true);
        break;
      case 'error':
        setOpenErrorToast(true);
        break;
      default:
        break;
    }
  };
  const closeToast = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenErrorToast(false);
    setOpenSuccessToast(false);
  };

  const getCapitalizedString = (string) =>
    string
      .toLowerCase()
      .split(' ')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  const getInitials = (string) =>
    string
      .split(' ')
      .map((word) => word[0].toUpperCase())
      .join('');

  const handleClassSignIn = async () => {
    //Check if they have any classes remaining
    if (Number(user.classStats.classesRemaining) === 0) {
      //Give them a toast unable to sign in , please add more classes
      openToast('error');
      return;
    }

    //They have a class
    //Change their class remaining and class taken and make sure they havent signed in +1 today
    //Make sure they havent already signed in today
    let signedInQuerySnapshot;

    signedInQuerySnapshot = await firebase
      .firestore()
      .collection('signed_in_users')
      .where('uid', '==', `${user.uid}`)
      .get();

    if (signedInQuerySnapshot.docs.length > 0) {
      console.log('You are already signed in');
      return;
    }

    user.classStats.classesTaken++;
    user.classStats.classesRemaining--;
    try {
      await firebase
        .firestore()
        .collection('class_accounts')
        .doc(user.uid)
        .update({ ...user });
    } catch (e) {
      console.log('There was an error updating the class accounts: ', e);
    }

    //Send a list to chris of people who are signed in
    const d = new Date();
    try {
      await firebase
        .firestore()
        .collection('signed_in_users')
        .add({
          name: user.name,
          date: d,
          time: `${d.toLocaleTimeString(undefined, {
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
          })}`,
          remaining: user.classStats.classesRemaining,
          uid: user.uid,
        });
    } catch (e) {
      console.log('There was an error adding to the sign in users account', e);
    }

    //Bring a toast to the bottom
    openToast('success');
  };

  const handleSignOut = () => {
    firebase
      .auth()
      .signOut()
      .then(() => {
        // Sign-out successful.
        history.push('/');
      })
      .catch((error) => {
        // An error happened.
        console.log('Sign out error: ' + error);
      });
  };

  return (
    <div className={classes.content}>
      {user && user.name ? (
        <>
          <h1>
            {user.lang === 'English'
              ? 'Account Information'
              : 'Información de Cuenta'}
          </h1>
          <div className={classes.avatarDiv}>
            <Avatar className={classes.avatar}>{getInitials(user.name)}</Avatar>
            <h2>{getCapitalizedString(user.name)}</h2>
          </div>
          <div className={classes.sliderGroup}>
            <div>
              <h4>
                {' '}
                {user.lang === 'English' ? 'Bachata Level' : 'Nivel de Bachata'}
              </h4>
              <Slider
                value={user.bachataLevel}
                className={classes.slider}
                step={10}
                marks={levelMarks}
                disabled
              />
            </div>
            <div>
              <h4>
                {' '}
                {user.lang === 'English' ? 'Salsa Level' : 'Nivel de Salsa'}
              </h4>
              <Slider
                value={user.salsaLevel}
                className={classes.slider}
                step={10}
                marks={levelMarks}
                disabled
              />
            </div>
          </div>
          <h3>
            {user.lang === 'English'
              ? 'Classes Remaining:'
              : 'Las Clases Restantes:'}{' '}
            {user.classStats.classesRemaining}
            <br />{' '}
            {user.lang === 'English' ? 'Referred By: ' : 'Recomendado por: '}
            {user.referredBy}
          </h3>
          <p>
            {user.lang === 'English' ? 'Language: ' : 'Idioma: '}
            {user.lang}
            <br />
            {user.lang === 'English' ? 'Email: ' : 'Correo Electrónico: '}
            {user.email}
            <br />
            {user.lang === 'English' ? 'Phone: ' : 'Numero de Celular: '}
            {user.phone}
            <br />
            {user.lang === 'English' ? 'DOB: ' : 'Fecha De Nacimiento: '}
            {user.dob}
          </p>
          {/* <h3></h3> */}
          <Button
            className={classes.button}
            variant='outlined'
            color='secondary'
            onClick={handleClassSignIn}
          >
            {user.lang === 'English'
              ? 'Sign In For Class Now!'
              : 'Iniciar Sesión para las Clases'}
          </Button>
          <Snackbar
            open={openErrorToast}
            autoHideDuration={6000}
            onClose={closeToast}
          >
            <Alert onClose={closeToast} severity='error'>
              {user.lang === 'English'
                ? ' Unable to Sign In for class. Please add more classes to your account.'
                : 'No se pudo iniciar la sesión para las clases. Por favor, agrega mas clases a su cuenta.'}
            </Alert>
          </Snackbar>
          <Snackbar
            open={openSuccessToast}
            autoHideDuration={6000}
            onClose={closeToast}
          >
            <Alert onClose={closeToast} severity='success'>
              {user.lang === 'English'
                ? "You are now signed-in for today's class! PLEASE LOGOUT!"
                : 'Ya esta registrado para las clases de hoy. Por favor, cierre la la sesión'}
            </Alert>
          </Snackbar>
          <Button
            className={classes.button}
            variant='contained'
            color='secondary'
            onClick={handleSignOut}
          >
            {user.lang === 'English' ? 'Logout' : 'Cerrar Sesión'}
          </Button>{' '}
        </>
      ) : (
        <CircularProgress />
      )}
    </div>
  );
};

export default AccountInfo;
